module.exports = __webpack_public_path__ + "static/media/1_3.19b9f003.png";